export enum StopGoIconStatus {
  STOP = 'stop',
  GO = 'go',
}
